
function checkIfPhoneNumberIsValid (phone) {
    var num = phone.replace(/[^0-9]/g, '');
    return parseInt(num,10);
}

export const doesTrainerHaveValidPhoneNumber = (phone) => {
    //var phone = this.state.phone;

    ////   Step 1. Extract Digits from Number in DB   ////
    var digits  = checkIfPhoneNumberIsValid(phone)
    console.log("only digits: " + digits);

    if(isNaN(digits)) {
        console.log("not a number, dude.");
        return false;
    }

    ////   Step 2. If number doesn't have a '1' in front of the area code, add it  ////
    var has1 = digits.toString().charAt(0);

    if(has1 != 1) {
        console.log("Does not have a 1.");
        digits = "+1"+digits;
    }

    ////   Step 3. Does number have 11 digits? Incl '1'  ////
    var digit_lgth = digits.toString().length;
    console.log("count digits: " + digit_lgth);

    if(digit_lgth < 11 || digit_lgth > 12) {
        console.log("not enough digits or too many.");
        return false;
    }

    console.log("2. digits: " + digits);

    return digits;
}



// WEBPACK FOOTER //
// ./src/utils/CheckIfValidPhoneNumber.js